<template>
  <v-layout
    column
    style="height: 100%"
  >
    <v-layout align-center>
      <div class="panelTitle">
        <span
          v-if="isBindCelllPhone"
        >
          設置您在轉運倉的收件人手機門號
        </span>
        <span
          v-else
        >
          登入
        </span>
      </div>
      <v-spacer />
      <v-btn
        v-if="showClose"
        icon
        small
        @click="$emit('close')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <div class="mt-4">
      <v-form ref="form">
        <v-text-field
          v-model="user.cellphone"
          :rules="[
            $store.state.validationRules.required,
            $store.state.validationRules.cellphone,
          ]"
          solo
          prepend-inner-icon="person"
          label="手機號碼"
          type="text"
        />
        <template
          v-if="passLogin"
        >
          <v-text-field
            id="password"
            v-model="user.password"
            :rules="[
              $store.state.validationRules.required,
              $store.state.validationRules.password,
            ]"
            :error="!!passwordMessage"
            :error-messages="passwordMessage"
            solo
            prepend-inner-icon="lock"
            name="password"
            label="密碼"
            type="password"
          />
        </template>
      </v-form>

      <v-form
        v-if="!passLogin"
        ref="form2"
      >
        <v-layout align-center>
          <v-flex>
            <v-text-field
              v-model="user.captcha"
              :rules="[
                $store.state.validationRules.required,
                $store.state.validationRules.captcha,
              ]"
              :error="!!passwordMessage"
              :error-messages="passwordMessage"
              prepend-icon="code"
              label="驗證碼"
              type="text"
            />
          </v-flex>
          <v-btn
            :disabled="captchaTimer > 0"
            :loading="sendLoading"
            color="info"
            class="mr-0"
            small
            @click="sendSignupCaptcha"
          >
            <span v-if="captchaTimer > 0">
              {{ captchaTimer }} 重新獲取
            </span>
            <span v-else-if="sentCaptch">
              重發驗證碼
            </span>
            <span v-else>
              取得驗證碼
            </span>
          </v-btn>
        </v-layout>
      </v-form>

      <v-btn
        :loading="submitLoading"
        color="orange white--text mt-2"
        block
        @click="submit"
      >
        <template v-if="isBindCelllPhone">
          完成
        </template>
        <template v-else>
          立即登入
        </template>
      </v-btn>
    </div>

    <v-layout class="mt-3 px-2">
      <a
        class="orange--text"
        @click="showResetPasswordDialog = true"
      ><u>忘記密碼？</u></a>
      <v-spacer />
      <div>
        <a
          v-if="passLogin === true"
          class="grey--text"
          @click="passLogin = false"
        ><u>簡訊驗證碼登入</u></a>
        <a
          v-else
          class="black--text"
          @click="passLogin = true"
        ><u>密碼登入</u></a>
      </div>
    </v-layout>
    <!-- <div class="mt-3 text-xs-center">
      還沒帳號？
      <a
        class="orange--text"
        @click="$emit('toSignup')"><u>前往註冊</u></a>
    </div> -->

    <v-spacer />
    <div
      v-if="!isBindCelllPhone"
      class="mt-4"
    >
      <v-layout class="ma-0">
        <!-- <v-btn
          small
          color="#4267b2"
          class="white--text"
          @click="fbLogin"
        >
          <i class="iconfont iconFacebook mr-2" />
          使用 Facebook 登入
        </v-btn> -->
        <v-spacer />
        <v-btn
          small
          color="orange white--text"
          @click="$emit('toSignup')"
        >
          加入會員
        </v-btn>
      </v-layout>
    </div>

    <ResetPasswordDialog
      :showDialog.sync="showResetPasswordDialog"
      type="find"
    />
  </v-layout>
</template>

<script>
import { getAccessToken } from '@g/utils/fbUtils'
import ResetPasswordDialog from './ResetPasswordDialog'

export default {
  components: {
    ResetPasswordDialog
  },
  props: {
    showClose: Boolean,
  },
  data () {
    return {
      showResetPasswordDialog: false,

      submitLoading: false,

      captchaTimer: 0,
      sentCaptch: false,
      sendLoading: false,
      needCatptch: false, // 需要验证码

      captchaWidgetId: 0,
      gaptchPromise: {},

      passLogin: true,

      user: {
        cellphone: '',
        password: '',
        captcha: ''
      },
      passwordMessage: '',
    }
  },
  computed: {
    installedCrx () {
      return this.$store.state.installedCrx
    },
    isBindCelllPhone () {
      return this.$store.state.userSignUpForm.fbAccessToken || this.$store.state.userSignUpForm.appleIdentityToken
    },
  },
  watch: {
    'user.password' () {
      this.passwordMessage = ''
    },
    'user.captcha' () {
      this.passwordMessage = ''
    },
  },
  mounted () {
    // 机器人验证
    if (!window.grecaptcha) {
      const script = document.createElement('script')
      script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=explicit'
      document.body.appendChild(script)
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.gaptchPromise = {
          resolve,
          reject
        }
        if (this.captchaWidgetId) {
          window.grecaptcha.reset(this.captchaWidgetId)
          window.grecaptcha.execute(this.captchaWidgetId)
          return
        }
        setTimeout(() => {
          this.captchaWidgetId = window.grecaptcha.render('signGrecaptcha', {
            sitekey: '6LcgpqMUAAAAAPlMI69DQtsZ5hGDpXEDP5SKcyqL',
            size: 'invisible',
            isolated: true,
            callback: token => {
              console.log('Verified: not robot', token)
              this.gaptchPromise.resolve(token)
            },
            'error-callback': () => {
              this.gaptchPromise.reject(new Error('验证失败'))
            }
          })
          window.grecaptcha.execute(this.captchaWidgetId)
        }, 1000)
      })
    },
    async sendSignupCaptcha () {
      if (!this.$refs.form.validate()) return
      try {
        this.sendLoading = true
        let gRecaptchaResponse
        if (this.needCatptch) {
          gRecaptchaResponse = await this.validate()
        }
        this.$store
          .dispatch('user/login/signupSendCaptcha', {
            cellphone: this.user.cellphone,
            gRecaptchaResponse,
            alibabaOpenUserId: this.$route && this.$route.query.alibabaOpenUserId,
          })
          .then(res => {
            if (!res.data.error) {
              this.sentCaptch = true
              this.captchaTimer = 60
              const tiemr = setInterval(() => {
                this.captchaTimer--
                if (this.captchaTimer < 1) {
                  clearInterval(tiemr)
                  // 重置机器人验证
                }
              }, 1000)
            } else if (res.data.name === 'gRecaptchaResponseEmpty') {
              this.needCatptch = true
            }
          })
      } finally {
        this.sendLoading = false
      }
    },
    async passLoginSubmit () {
      try {
        if (!this.$refs.form.validate()) return
        this.submitLoading = true
        const res = await this.$store.dispatch('user/login/loginPwd', {
          username: this.user.cellphone,
          password: this.user.password
        })
        if (!res.data.error) {
          if (res.data.model.status === 404) {
            this.passwordMessage = '該帳戶已註銷'
          } else {
            if (localStorage.loginCount) {
              localStorage.loginCount = Number(localStorage.loginCount) + 1
            } else {
              localStorage.loginCount = '1'
            }
            if (this.$store.state.project === 'mgb-pc') {
              // this.$router.push({ name: 'DgorderCreate' })
              location.reload()
            } else {
              if (sessionStorage.getItem('redirect')) {
                this.$router.replace({ path: sessionStorage.getItem('redirect') })
              } else {
                this.$router.replace({ name: 'Home' })
              }
            }
          }
        } else if (res.data.error === 'password') {
          this.passwordMessage = '賬戶或密碼錯誤'
        } else if (res.data.error === 'NewDeviceNeedCellphoneCaptcha') {
        } else {
          this.passwordMessage = res.data.message || res.data.error
        }
      } finally {
        this.submitLoading = false
      }
    },
    async codeLoginSubmit () {
      try {
        if (!this.$refs.form.validate() || !this.$refs.form2.validate()) return
        this.submitLoading = true
        const params = {
          cellphone: this.user.cellphone,
          captcha: this.user.captcha
        }
        params.fbAccessToken = this.$store.state.userSignUpForm.fbAccessToken
        params.appleIdentityToken = this.$store.state.userSignUpForm.appleIdentityToken
        if (this.$route && this.$route.query.alibabaOpenUserId) {
          params.alibabaOpenUserId = this.$route.query.alibabaOpenUserId
        }

        const res = await this.$store.dispatch('user/login/signup', params)
        if (!res.data.error) {
          if (res.data.model.status === 404) {
            this.passwordMessage = '該帳戶已註銷'
          } else {
            if (localStorage.loginCount) {
              localStorage.loginCount = Number(localStorage.loginCount) + 1
            } else {
              localStorage.loginCount = '1'
            }
            if (this.$store.state.project === 'mgb-pc') {
              location.reload()
            } else {
              if (sessionStorage.getItem('redirect')) {
                this.$router.replace({ path: sessionStorage.getItem('redirect') })
              } else {
                const query = {}
                if (this.$route.query.searchKey) {
                  query.searchKey = this.$route.query.searchKey
                }
                this.$router.replace({
                  name: 'Home',
                  query,
                })
              }
            }
          }
        } else {
          this.passwordMessage = res.data.message || res.data.error
        }
      } finally {
        this.submitLoading = false
      }
    },
    async submit () {
      if (!this.installedCrx && localStorage.loginCount > 0 && this.$store.state.project === 'pc') {
        this.$snackbar('你好像沒有用鑰匙，把鎖頭破壞了！', {
          color: 'error'
        })
        return
      }
      if (this.passLogin) {
        this.passLoginSubmit()
      } else {
        this.codeLoginSubmit()
      }
    },
    async fbLogin () {
      if (!this.installedCrx && localStorage.loginCount > 0 && this.$store.state.project === 'pc') {
        this.$snackbar('你好像沒有用鑰匙，把鎖頭破壞了！', {
          color: 'error'
        })
        return
      }
      const token = await getAccessToken()
      const res = await this.$store.dispatch('user/login/loginPwd', {
        username: token
      })
      console.log(res)
      if (res.data.name === 'fbidNotExists') {
        this.$store.state.userSignUpForm.fbAccessToken = token
        this.passLogin = false
        // TODO 未关联 FB 账号
      } else if (!res.data.error) {
        if (this.$store.state.project === 'mgb-pc') {
          location.reload()
        } else {
          if (sessionStorage.getItem('redirect')) {
            this.$router.replace({ path: sessionStorage.getItem('redirect') })
          } else {
            this.$router.replace({ name: 'Home' })
          }
        }
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
.panelTitle {
  font-size: 16px;
  font-weight: bold;
  > span {
    border-bottom:2px solid #FF9800;
  }
}
</style>
